<template>
  <b-container fluid>
    <b-row>
      <b-col class="text-center">
        <h1 style="margin-top:25px;">Thank you for submitting your enrollment application.</h1>
        <h2> The VaxCheck team will contact you within five business days with next steps.</h2>
        
        <div style="margin-top:45px; font-weight:700">
          <router-link :to="{name: 'landing'}">
            <b-button class="bg-mdh" id="btnHome" role="button">Return Home</b-button>
          </router-link>
        </div>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>

export default {
  name: 'thanks',


}
</script>
